module.exports = __webpack_public_path__ + "img/i11.e6602fd2.svg";